export default __webpack_public_path__ + "static/media/HT.9955388e.ico";